import "./latest-research.css";
import React from "react";
import { MenuAlt as BlockMenuAlt } from "./tabsMenu/MenuAlt";
import { AutoCompleteSearchBox } from "../search/searchBar/AutoCompleteSearchBox";
import { ViewLayout } from "./publications/ViewLayout";
import { ResearchBreadcrumb } from "./publications/breadcrumb/Breadcrumb";
import { JAPIPublicationLoader } from "./publications/JAPIPublicationLoader";
import ErrorBoundary from "lib/ErrorBoundary";
import { ServiceNotification } from "./notification/ServiceNotification";
import { features } from "app/features";

export const LatestResearch = ({ match }) => {
  const { assetClass, region, product } = match.params;

  return (
    <ErrorBoundary className="px-2">
      {features.serviceNotifications && <ServiceNotification />}
      <BlockMenuAlt asset={assetClass} region={region} product={product} />
      <ResearchBreadcrumb />
      <AutoCompleteSearchBox placeholder="Search within this section..." />

      <JAPIPublicationLoader
        scrollToTop={false}
        render={(publications, _noop, data) => <ViewLayout publications={publications} data={data} />}
      />
    </ErrorBoundary>
  );
};
